import {
    BarekamColumns,
    OrdersTableColumn,
    WarehouseWorkerColumns
} from "../../../../../pages/orders/my/models/column-models";

const internalTrackingNumberColumn: OrdersTableColumn = { field: 'internalTrackingNumber', headerName: 'order_list_barekam_tracking', variant: BarekamColumns.barekamTrack};
const nameColumn: OrdersTableColumn = { field: 'name', headerName: 'order_list_name', variant: BarekamColumns.text};
const recipientColumn: OrdersTableColumn = { field: 'recipient', headerName: 'order_list_recipient', variant: BarekamColumns.recipient};
const weightColumn: OrdersTableColumn = { field: 'weight', headerName: 'order_list_weight', variant: BarekamColumns.weight}
const priceColumn: OrdersTableColumn = { field: 'price', headerName: 'order_list_price', variant: BarekamColumns.price}
const locationColumn: OrdersTableColumn = { field: '', headerName: 'order_list_location', variant: WarehouseWorkerColumns.location}
const trackRecordColumn: OrdersTableColumn = { field: 'trackRecord', headerName: 'order_list_state', variant: BarekamColumns.trackStatus}
const actionsColumn: OrdersTableColumn = { field: '', headerName: 'order_list_actions', variant: WarehouseWorkerColumns.bulkActionPopupActions}

export const standardDialogColumns = [
    internalTrackingNumberColumn,
    nameColumn,
    recipientColumn,
    weightColumn,
    priceColumn,
    locationColumn,
    trackRecordColumn,
    actionsColumn
]
